// On the product page, .product__media-wrapper is grid-stretched to match the ROW height —
// but that row height is driven by the media image's own tall intrinsic aspect ratio (via
// media-fit-cover's height:100% chain), not by the buy box's actual content height. The buy
// box (.product__info-container) ends up much shorter, leaving the image extending well past
// its bottom. This measures where the buy box's bottom edge actually falls on the page and
// sizes the media wrapper to land its own bottom edge at that same point — using the bottom
// positions directly (not just matching heights) because the two columns don't necessarily
// start at the same top offset (e.g. the buy box's own title/padding above the price).
(function () {
  var mediaWrapper;
  var infoContainer;

  function syncHeight() {
    if (!mediaWrapper || !infoContainer) return;

    // 1200px, not the two-column layout's own 990px breakpoint (.product--large/medium/small's
    // max-width overrides in section-main-product.css) — the page already goes side-by-side at
    // 990px, but with a buy-box column still narrow enough there (and up to ~1200px) that its
    // content wraps onto extra lines, making the computed target height wildly taller than the
    // image's own aspect ratio could reasonably fill without an extreme, cropped-looking zoom.
    // Below 1200px the image just keeps its natural aspect-ratio size instead (same as mobile).
    if (window.matchMedia('(min-width: 1200px)').matches) {
      var infoBottom = infoContainer.getBoundingClientRect().bottom;
      var mediaTop = mediaWrapper.getBoundingClientRect().top;
      var targetHeight = infoBottom - mediaTop;
      if (targetHeight > 0) {
        mediaWrapper.style.height = targetHeight + 'px';
      }
    } else {
      mediaWrapper.style.height = '';
    }
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    mediaWrapper = document.querySelector('.product__media-wrapper');
    infoContainer = document.querySelector('.product__info-container');
    if (!mediaWrapper || !infoContainer) return;

    syncHeight();
    window.addEventListener('load', syncHeight);
    window.addEventListener('resize', debounce(syncHeight, 150));
    document.addEventListener('product-info:loaded', syncHeight);

    // Some buy-box content (Shop Pay's dynamic checkout button, etc.) loads in and changes
    // height asynchronously after our other listeners have already fired — watch the buy box
    // directly rather than guessing every event that could affect it.
    if (window.ResizeObserver) {
      var debouncedSync = debounce(syncHeight, 100);
      new ResizeObserver(debouncedSync).observe(infoContainer);
    }
  });
})();
